import { useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';

import { CachedBonuses } from '../../../../../types/bonus';
import { QueryKey } from '../../hooks/types';

const removeCommentFromFeed = (id: string, cached?: CachedBonuses) => {
	if (!cached) {
		return cached;
	}

	return produce(cached, (draft) => {
		draft.pages = draft.pages.map((page) => {
			return produce(page, (draft) => {
				draft.data.result = draft.data.result.map((result) => {
					return produce(result, (draft) => {
						draft.child_bonuses = draft.child_bonuses.filter((child) => child.id !== id);

						return draft;
					});
				});
			});
		});
	});
};

export const useRemoveCommentFromQueriesData = () => {
	const queryClient = useQueryClient();

	return (id: string) => {
		queryClient.setQueriesData<CachedBonuses>([QueryKey.BonusesInfinite], (cached) => removeCommentFromFeed(id, cached));
	};
};
